// Dark mode is scoped to the study surfaces (the dashboard and the textbook)
// plus the account surfaces that lead into them (sign-in, sign-up, onboarding).
// The `.dark` class is toggled on <html> (so portaled dialogs inherit it too),
// but only on those routes; everywhere else is forced light so marketing can
// never inherit dark, and the textbook stays light for signed-out crawlers.

export const THEME_STORAGE_KEY = "dashboard-theme";

// `data-themed` also swaps --primary from the landing page's black to the
// board accent, which is why the auth and onboarding routes are in here: they
// belong to the app, not to marketing.
export const THEMED_ROUTE_PREFIXES = [
  "/dashboard",
  "/textbook",
  "/onboarding",
  "/login",
  "/signup",
];

// Runs before first paint in <head> to set the initial class with no flash.
// Mirrors the client provider's logic: dark only on themed routes, default
// light (dark applies only when the user has explicitly chosen it).
// Also sets data-themed on those routes so CSS can apply brand colors.
export const themeInitScript = `(function(){try{var d=document.documentElement;var p=location.pathname;var themed=${THEMED_ROUTE_PREFIXES.map(
  (prefix) => `p.indexOf('${prefix}')===0`,
).join("||")};if(!themed){d.classList.remove('dark');d.removeAttribute('data-themed');return;}d.setAttribute('data-themed','');var m=localStorage.getItem('${THEME_STORAGE_KEY}');d.classList.toggle('dark',m==='dark');}catch(e){}})();`;
